import {
  Table,
  TableHeader,
  TableBody,
  TableColumn,
  TableRow,
  TableCell
} from "@heroui/table";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "@heroui/modal";
import {Button} from '@heroui/react';
import { useGetEmailRecords } from '../hooks/useGetEmailRecords';

const EmailRecordsModal = ({campaign, dismissModal}) => {
  const emailRecords = useGetEmailRecords(campaign._id);

  const exportCsv = () => {
    let csvRows = [['Name', 'Email', 'Sent']];
    emailRecords?.map(line => csvRows.push([line.fullname, line.source, line.created_at].join(',')));
    const finalCsv = csvRows.join('\n');
    const blob = new Blob([finalCsv], {type: 'text/csv'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'records.csv';
    a.click();
  };

  return (
    <Modal placement='top' size='4xl' scrollBehavior='inside' isOpen={true} isDismissable={true} isKeyboardDismissDisabled={true} onClose={dismissModal}>
      <ModalContent>
         <ModalHeader className='flex flex-col gap-1'>
           {campaign.subject}
           <Button onPress={() => exportCsv()} href=''>Export CSV</Button>
         </ModalHeader>
         <ModalBody>
           <Table aria-label="Settings" color='danger' shadow="md">
             <TableHeader columns={3}>
               <TableColumn>Name</TableColumn>
               <TableColumn>Sender</TableColumn>
               <TableColumn>Date</TableColumn>
             </TableHeader>
             <TableBody>
               {
                 emailRecords?.map(record => {
                    return (
                      <TableRow>
                        <TableCell className='htr'>{record.fullname}</TableCell>
                        <TableCell className='htr'>{record.source}</TableCell>
                        <TableCell className='htr'>
                          {new Date(record.created_at).toDateString().split(' ').slice(1, 4).join(' ')} {new Date(record.created_at).toLocaleTimeString()}
                        </TableCell>
                      </TableRow>
                    );
                })
              }
            </TableBody>
         </Table>
       </ModalBody>
       <ModalFooter>
       </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default EmailRecordsModal;
